import { pressLogos, pressMentions } from '../../data/content';

/** Of er pers is om te tonen. */
export const hasPress = () => pressLogos.length > 0 || pressMentions.length > 0;

/**
 * "Aanbevolen in": logo's en namen van media, als regel bovenaan "wie het ook gebruiken" op Over.
 * Geen eigen vlak meer: pers en vaste cliënten zijn samen het bewijs. Zonder vermeldingen niets.
 */
export function PressStrip() {
  if (!hasPress()) return null;
  return <div className="flex flex-col items-center gap-6 border-b border-ink/15 pb-12 lg:flex-row lg:justify-between lg:gap-12" data-id="element-8729" data-mp="15s7mssp5htv4">
      <p className="whitespace-nowrap text-[14px] text-muted" data-id="element-8730" data-mp="1aru3jc46ts8o">Aanbevolen in</p>
      <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 sm:gap-x-14" data-id="element-8731" data-mp="1fn9ftzmjrg2z">
        {pressLogos.map(logo => <li key={logo.name} data-id="element-8732" data-mp="2r3zmfjuvu9x4">
            <img src={logo.image} alt={logo.name} loading="lazy" className={`${logo.size === 'lg' ? 'h-10 sm:h-12' : 'h-6 sm:h-7'} w-auto opacity-80 mix-blend-multiply`} data-id="element-8733" data-mp="2r4r73zmxyn8m" />
          </li>)}
        {pressMentions.map(name => <li key={name} className="type-name text-muted" data-id="element-8734" data-mp="cce2mzt0gg3v">
            {name}
          </li>)}
      </ul>
    </div>;
}